(function () {
  'use strict';

  window.LarinePouchesEnableCheckoutAtc = function () {
    window.LarinePouchesAtcMode = 'checkout';
  };

  function shouldRedirectPouchesToCheckout() {
    return window.LarinePouchesAtcMode === 'checkout'
      && document.body.classList.contains('temp-pouches');
  }

  var pouchesJsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function discountCodesFromCart(cart) {
    var out = [];
    var seen = {};
    function push(raw) {
      var code = String(raw || '').trim();
      if (!code) return;
      var key = code.toUpperCase();
      if (seen[key]) return;
      seen[key] = true;
      out.push(code);
    }
    if (cart && Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach(function (entry) {
        push(typeof entry === 'string' ? entry : entry && entry.code);
      });
    }
    if (cart && typeof cart.discount_code === 'string') push(cart.discount_code);
    return out;
  }

  function mergePouchesDiscountCodes(existing, nextCode) {
    var out = [];
    var seen = {};
    function push(raw) {
      var code = String(raw || '').trim();
      if (!code) return;
      var key = code.toUpperCase();
      if (seen[key]) return;
      seen[key] = true;
      out.push(code);
    }
    var list = (Array.isArray(existing) ? existing : []).concat(nextCode ? [nextCode] : []);
    // Keep 50-OFF first so 5-OFF cannot shadow it when Shopify applies the list.
    list.filter(function (c) { return String(c).toUpperCase() === '50-OFF'; }).forEach(push);
    list.filter(function (c) { return String(c).toUpperCase() !== '50-OFF'; }).forEach(push);
    return out;
  }

  function fetchCartDiscountCodes() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      if (!res.ok) return [];
      return res.json().then(discountCodesFromCart);
    }).catch(function () {
      return [];
    });
  }

  function checkoutUrlWithCodes(codes) {
    if (!codes || !codes.length) return '/checkout';
    return '/discount/' + codes.map(encodeURIComponent).join(',') +
      '?redirect=' + encodeURIComponent('/checkout');
  }

  function applyMergedPouchesDiscount(codeToApply, preserved) {
    var next = String(codeToApply || '').trim();
    return fetchCartDiscountCodes().then(function (current) {
      var merged = mergePouchesDiscountCodes((preserved || []).concat(current), next);
      if (!merged.length) return merged;
      window.__larineCheckoutDiscountUrl = checkoutUrlWithCodes(merged);
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: pouchesJsonHeaders,
        body: JSON.stringify({ discount: merged.join(',') }),
      }).then(function (res) {
        if (!res.ok) return null;
        return res.json().catch(function () { return null; });
      }).then(function (cart) {
        var codes = discountCodesFromCart(cart);
        var hasNew = !next || codes.some(function (c) {
          return c.toUpperCase() === next.toUpperCase();
        });
        if (hasNew) return merged;
        return fetch('/discount/' + merged.map(encodeURIComponent).join(','), {
          credentials: 'same-origin',
          redirect: 'manual',
        }).then(function () { return merged; }).catch(function () { return merged; });
      });
    });
  }

  function initBundle(root) {
    if (root.dataset.pouchesInit === 'true') return;
    root.dataset.pouchesInit = 'true';

    var steppers = Array.prototype.slice.call(root.querySelectorAll('[data-flavor-stepper]'));
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-pouches-tier]'))
      .map(function (el) {
        var sellingPlanId = el.getAttribute('data-tier-selling-plan-id');
        return {
          el: el,
          qty: parseInt(el.getAttribute('data-tier-qty'), 10) || 0,
          sellingPlanId: sellingPlanId ? parseInt(sellingPlanId, 10) : null,
          saleCents: parseInt(el.getAttribute('data-tier-sale-cents'), 10) || 0,
        };
      })
      .sort(function (a, b) { return a.qty - b.qty; });
    var tiersContainer = root.querySelector('[data-pouches-tiers]');
    var track = root.querySelector('.pouches-bundle__tier-track');
    var trackFill = root.querySelector('[data-tier-track-fill]');
    var dots = tiers.map(function (tier) {
      return tier.el.querySelector('[data-tier-dot]');
    });
    var ctaButton = root.querySelector('[data-pouches-add-to-cart]');
    var ctaText = root.querySelector('[data-pouches-cta-text]');
    var statusEl = root.querySelector('[data-pouches-status]');
    var promoEl = root.querySelector('[data-pouches-promo]');
    var promoHeadline = root.querySelector('[data-promo-headline]');
    var promoHeadlineText = root.querySelector('[data-promo-headline-text]');
    var promoBadge = root.querySelector('[data-promo-badge]');
    var promoCompare = root.querySelector('[data-promo-compare]');
    var promoSale = root.querySelector('[data-promo-sale]');
    var promoSavings = root.querySelector('[data-promo-savings]');
    var shippingEl = root.querySelector('[data-pouches-shipping]');
    var shippingDefault = root.querySelector('[data-shipping-default]');
    var shippingDynamic = root.querySelector('[data-shipping-dynamic]');
    var shippingNeededQty = root.querySelector('[data-shipping-needed-qty]');
    var freeShippingThresholdCents = parseInt(shippingEl && shippingEl.getAttribute('data-free-shipping-threshold-cents'), 10) || 5000;
    var minBoxes = parseInt(ctaButton && ctaButton.getAttribute('data-min-boxes'), 10) || tiers[0].qty || 1;
    var buttonTemplate = (ctaButton && ctaButton.getAttribute('data-button-template')) || 'Add {quantity} Boxes';
    var enabledButtonText = (ctaButton && ctaButton.getAttribute('data-enabled-button-text')) || 'Try It Now';
    var cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';
    var discountCode = root.getAttribute('data-discount-code') || '';
    var currencySymbol = root.getAttribute('data-currency-symbol') || '$';
    var regularUnitCents = parseInt(root.getAttribute('data-regular-unit-cents'), 10) || 0;

    function formatMoney(cents) {
      var amount = (Number(cents) || 0) / 100;
      var parts = amount.toFixed(2).split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return currencySymbol + intPart + '.' + parts[1];
    }

    function quantities() {
      return steppers.map(function (stepper) {
        return parseInt(stepper.querySelector('[data-stepper-qty]').textContent, 10) || 0;
      });
    }

    function total() {
      return quantities().reduce(function (sum, qty) { return sum + qty; }, 0);
    }

    function updateStepperState(stepper, qty) {
      stepper.querySelector('[data-stepper-qty]').textContent = String(qty);
      var minusBtn = stepper.querySelector('[data-stepper-minus]');
      if (minusBtn) minusBtn.disabled = qty <= 0;
    }

    function positionTrack() {
      if (!track || !tiersContainer || dots.length < 2 || !dots[0] || !dots[dots.length - 1]) return;

      var containerRect = tiersContainer.getBoundingClientRect();
      var firstRect = dots[0].getBoundingClientRect();
      var lastRect = dots[dots.length - 1].getBoundingClientRect();

      var firstCenterX = firstRect.left + firstRect.width / 2 - containerRect.left;
      var lastCenterX = lastRect.left + lastRect.width / 2 - containerRect.left;
      var centerY = firstRect.top + firstRect.height / 2 - containerRect.top;

      track.style.left = firstCenterX + 'px';
      track.style.right = 'auto';
      track.style.width = (lastCenterX - firstCenterX) + 'px';
      track.style.top = centerY + 'px';
    }

    function activeTierIndex(currentTotal) {
      var active = -1;
      for (var i = 0; i < tiers.length; i++) {
        if (currentTotal >= tiers[i].qty) active = i;
      }
      return active;
    }

    function render() {
      var currentTotal = total();
      var activeIndex = activeTierIndex(currentTotal);

      tiers.forEach(function (tier, i) {
        if (i === activeIndex) {
          tier.el.setAttribute('data-tier-active', '');
        } else {
          tier.el.removeAttribute('data-tier-active');
        }
        if (activeIndex >= 0 && i <= activeIndex) {
          tier.el.setAttribute('data-tier-reached', '');
        } else {
          tier.el.removeAttribute('data-tier-reached');
        }
      });

      if (trackFill) {
        var progress = 0;
        if (tiers.length > 1 && activeIndex >= 0) {
          progress = Math.round((activeIndex / (tiers.length - 1)) * 100);
        }
        trackFill.style.width = progress + '%';
      }

      positionTrack();

      var isEnabled = currentTotal >= minBoxes;
      var activeTier = isEnabled && activeIndex >= 0 ? tiers[activeIndex] : null;
      var saleTotalCents = activeTier ? activeTier.saleCents * currentTotal : 0;
      var compareTotalCents = activeTier ? regularUnitCents * currentTotal : 0;

      if (ctaText) {
        if (activeTier) {
          var html = escapeHtml(enabledButtonText);
          html += ' <span class="pouches-bundle__cta-divider">|</span> ';
          if (compareTotalCents > saleTotalCents) {
            html += '<s class="pouches-bundle__cta-compare">' + formatMoney(compareTotalCents) + '</s> ';
          }
          html += '<strong class="pouches-bundle__cta-sale">' + formatMoney(saleTotalCents) + '</strong>';
          ctaText.innerHTML = html;
        } else {
          ctaText.textContent = buttonTemplate.replace('{quantity}', minBoxes);
        }
      }
      if (ctaButton) {
        ctaButton.disabled = !isEnabled;
      }

      if (promoEl) {
        var nextTier = null;
        if (activeTier) {
          if (activeIndex < tiers.length - 1) {
            nextTier = tiers[activeIndex + 1];
          } else {
            var lastTier = tiers[tiers.length - 1];
            var stepQty = tiers.length > 1 ? (lastTier.qty - tiers[tiers.length - 2].qty) : lastTier.qty;
            if (stepQty <= 0) stepQty = lastTier.qty || 1;
            var milestonesPassed = Math.floor((currentTotal - lastTier.qty) / stepQty);
            nextTier = {
              qty: lastTier.qty + stepQty * (milestonesPassed + 1),
              saleCents: lastTier.saleCents,
            };
          }
        }

        if (activeTier) {
          var currentSavingsCents = compareTotalCents - saleTotalCents;

          if (promoSale) promoSale.textContent = formatMoney(saleTotalCents);
          if (promoCompare) {
            promoCompare.textContent = formatMoney(compareTotalCents);
            promoCompare.hidden = compareTotalCents <= saleTotalCents;
          }
          if (promoSavings) promoSavings.textContent = formatMoney(currentSavingsCents);

          if (nextTier) {
            var neededQty = nextTier.qty - currentTotal;
            var nextTierCompareCents = regularUnitCents * nextTier.qty;
            var nextTierSaleCents = nextTier.saleCents * nextTier.qty;
            var nextTierSavingsCents = nextTierCompareCents - nextTierSaleCents;

            if (promoHeadlineText) promoHeadlineText.textContent = 'Add ' + neededQty + ' more to get';
            if (promoBadge) promoBadge.textContent = formatMoney(nextTierSavingsCents) + ' off today';
            if (promoHeadline) promoHeadline.hidden = false;
          } else if (promoHeadline) {
            promoHeadline.hidden = true;
          }

          promoEl.hidden = false;
        } else {
          promoEl.hidden = true;
        }
      }

      if (shippingEl) {
        var remainingForFreeShipping = freeShippingThresholdCents - saleTotalCents;

        if (activeTier && remainingForFreeShipping > 0) {
          var neededShippingQty = Math.ceil(remainingForFreeShipping / activeTier.saleCents);
          if (shippingNeededQty) shippingNeededQty.textContent = neededShippingQty;
          if (shippingDynamic) shippingDynamic.hidden = false;
          if (shippingDefault) shippingDefault.hidden = true;
        } else {
          if (shippingDynamic) shippingDynamic.hidden = true;
          if (shippingDefault) shippingDefault.hidden = false;
        }
      }
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    steppers.forEach(function (stepper) {
      var qtyEl = stepper.querySelector('[data-stepper-qty]');
      var minusBtn = stepper.querySelector('[data-stepper-minus]');
      var plusBtn = stepper.querySelector('[data-stepper-plus]');

      updateStepperState(stepper, parseInt(qtyEl.textContent, 10) || 0);

      minusBtn.addEventListener('click', function () {
        var qty = parseInt(qtyEl.textContent, 10) || 0;
        if (qty <= 0) return;
        updateStepperState(stepper, qty - 1);
        render();
      });

      plusBtn.addEventListener('click', function () {
        var qty = parseInt(qtyEl.textContent, 10) || 0;
        updateStepperState(stepper, qty + 1);
        render();
      });
    });

    function showStatus(message, type) {
      if (!statusEl) return;
      statusEl.textContent = message;
      statusEl.hidden = !message;
      if (type) {
        statusEl.setAttribute('data-status-type', type);
      } else {
        statusEl.removeAttribute('data-status-type');
      }
    }

    if (ctaButton) {
      ctaButton.addEventListener('click', function () {
        var currentTotal = total();
        var activeIndex = activeTierIndex(currentTotal);
        var activeTier = activeIndex >= 0 ? tiers[activeIndex] : null;
        var sellingPlanId = activeTier ? activeTier.sellingPlanId : null;

        var items = [];
        steppers.forEach(function (stepper) {
          var qty = parseInt(stepper.querySelector('[data-stepper-qty]').textContent, 10) || 0;
          if (qty > 0) {
            var item = {
              id: parseInt(stepper.getAttribute('data-variant-id'), 10),
              quantity: qty,
            };
            if (sellingPlanId) item.selling_plan = sellingPlanId;
            items.push(item);
          }
        });

        if (items.length === 0) {
          var firstStepper = steppers[0];
          var fallbackItem = {
            id: parseInt(firstStepper.getAttribute('data-variant-id'), 10),
            quantity: minBoxes,
          };
          if (sellingPlanId) fallbackItem.selling_plan = sellingPlanId;
          items.push(fallbackItem);
        }

        ctaButton.disabled = true;
        showStatus('', null);

        var podcastCode =
          window.__podcastLpDiscount && String(window.__podcastLpDiscount.code || '').trim();
        var onPodcastLp = Boolean(podcastCode && window.location.pathname.indexOf('/pages/') !== -1);
        var codeToApply = podcastCode || discountCode;
        var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

        function postJson(url, body) {
          return fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: jsonHeaders,
            body: JSON.stringify(body),
          }).then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw new Error((data && data.message) || 'Request failed');
              return data;
            });
          });
        }

        function clearCart() {
          var clearUrl = (window.routes && window.routes.cart_clear_url) || '/cart/clear';
          if (clearUrl.indexOf('.js') === -1) {
            clearUrl = clearUrl.replace(/\/?$/, '') + '.js';
          }
          return fetch(clearUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          }).then(function (res) {
            if (!res.ok) throw new Error('Could not clear cart');
          });
        }

        window.__cartDrawerUpdating = true;

        var preservedCodes = [];
        var chain = onPodcastLp
          ? clearCart()
          : fetchCartDiscountCodes().then(function (codes) {
              preservedCodes = codes;
            });
        chain
          .then(function () {
            return postJson(cartAddUrl, { items: items });
          })
          .then(function () {
            return applyMergedPouchesDiscount(codeToApply, onPodcastLp ? [] : preservedCodes);
          })
          .then(function (merged) {
            var checkoutWithCodes = checkoutUrlWithCodes(
              merged && merged.length ? merged : (codeToApply ? [codeToApply] : [])
            );
            if (onPodcastLp) {
              window.location.href = checkoutWithCodes;
              return;
            }
            if (shouldRedirectPouchesToCheckout()) {
              window.location.href = window.__larineCheckoutDiscountUrl || checkoutWithCodes || '/checkout';
              return;
            }
            if (window.cartDrawerCustom) {
              window.cartDrawerCustom.refresh().then(function () {
                window.cartDrawerCustom.open();
              });
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            }
          })
          .catch(function (err) {
            showStatus(err.message || 'Something went wrong. Please try again.', 'error');
          })
          .finally(function () {
            window.__cartDrawerUpdating = false;
            ctaButton.disabled = false;
          });
      });
    }

    tiers.forEach(function (tier) {
      if (!tier.saleCents) return;
      var priceEl = tier.el.querySelector('[data-tier-price]');
      if (priceEl) priceEl.textContent = formatMoney(tier.saleCents) + '/ea';
    });

    positionTrack();
    render();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(positionTrack, 100);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(positionTrack);
    }
    window.addEventListener('load', positionTrack);
    root.addEventListener('larine:pouches-refresh', positionTrack);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-pouches-bundle]');
    roots.forEach(initBundle);
  }

  window.LarineInitPouchesBundles = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
